import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const faqData = [
  { q: 'Was ist der OOPBUY Spreadsheet?', a: 'Der OOPBUY Spreadsheet ist ein umfassendes Tool zur Verwaltung deiner Einkäufe auf Plattformen wie Taobao, Weidian und Yupoo. Es kombiniert Agent-Management, Qualitätskontrolle (QC), Bestellverfolgung und Versand-Tracking in einer einzigen, übersichtlichen Tabelle.' },
  { q: 'Ist OOPBUY kostenlos?', a: 'Die Basisnutzung des OOPBUY Spreadsheets ist kostenlos. Für erweiterte Funktionen wie automatisiertes QC-Tracking und Premium-Support gibt es kostenpflichtige Upgrades auf kaspreadsheet.com.' },
  { q: 'Wie funktioniert die Qualitätskontrolle (QC)?', a: 'Nachdem deine Bestellung im Warehouse eintrifft, werden Fotos von jedem Artikel gemacht. Du kannst diese QC-Bilder direkt im Spreadsheet einsehen und Artikel freigeben oder ablehnen, bevor sie nach Deutschland versendet werden.' },
  { q: 'Kann man nach Deutschland liefern lassen?', a: 'Ja! Der OOPBUY Spreadsheet unterstützt verschiedene Versandmethoden nach Deutschland, darunter DHL, EMS und spezielle Linien. Die Versandkosten werden transparent im Spreadsheet angezeigt.' },
  { q: 'Welche Plattformen werden unterstützt?', a: 'Der Spreadsheet ist optimiert für Taobao, Weidian, Yupoo und 1688. Du kannst Bestellungen von verschiedenen Sellern und Plattformen in einem einzigen Spreadsheet zusammenführen.' },
  { q: 'Wie sicher sind meine Daten?', a: 'Alle Daten werden verschlüsselt übertragen und gespeichert. Der Spreadsheet verwendet moderne Sicherheitsstandards und gibt deine persönlichen Daten nicht an Dritte weiter.' },
  { q: 'Kann ich mehrere Bestellungen gleichzeitig verwalten?', a: 'Absolut! Der OOPBUY Spreadsheet ist speziell für Batch-Bestellungen konzipiert. Du kannst hunderte Artikel von verschiedenen Sellern gleichzeitig tracken und verwalten.' },
  { q: 'Was ist ein Agent und brauche ich einen?', a: 'Ein Agent ist dein Vermittler in China, der die Bestellungen für dich abwickelt. Der OOPBUY Spreadsheet hilft dir, die Kommunikation mit deinem Agent zu optimieren und alle Bestellungen zentral zu dokumentieren.' },
  { q: 'Wie lange dauert der Versand nach Deutschland?', a: 'Die Versanddauer variiert je nach Methode: Express (5-10 Tage), Standard (10-20 Tage) und Economy (20-40 Tage). Im Spreadsheet siehst du für jede Bestellung die voraussichtliche Lieferzeit.' },
  { q: 'Unterstützt der Spreadsheet verschiedene Währungen?', a: 'Ja, du kannst Preise in CNY (chinesischer Yuan), USD und EUR anzeigen lassen. Die Umrechnung erfolgt automatisch basierend auf aktuellen Wechselkursen.' },
];

const relatedArticles = [
  { title: 'OOPBUY QC Guide für Deutschland', url: '/oopbuy-qc-guide' },
  { title: 'Versand nach Deutschland: Der komplette Leitfaden', url: '/oopbuy-versand-deutschland' },
  { title: 'OOPBUY Agent Vergleich 2025', url: '/oopbuy-agent-vergleich' },
  { title: 'Weidian Guide: Versteckte Schätze finden', url: '/oopbuy-weidian-guide' },
  { title: 'Yupoo Spreadsheet Integration Guide', url: '/oopbuy-yupoo-guide' },
];

export default function ArticlePage() {
  return (
    <>
      <Navbar />

      <main>
        {/* Article Hero */}
        <section className="relative w-full h-[420px] md:h-[550px] overflow-hidden mt-16">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20alongside%20fashion%20products%20on%20warm%20cream%20desk%20with%20soft%20natural%20light%20editorial%20photography%20clean%20german%20aesthetic%20minimalist%20composition%20warm%20earthy%20tones%20professional%20atmosphere&width=1800&height=1100&seq=article-hero-v1&orientation=landscape"
              alt="OOPBUY Spreadsheet Guide"
              title="Was ist OOPBUY Spreadsheet - Der ultimative Guide"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="relative z-10 h-full flex flex-col justify-center px-4 md:px-6 max-w-[1280px] mx-auto w-full">
            <p className="text-white/70 text-xs md:text-sm mb-3 font-label tracking-wider uppercase">Ultimate Guide · Aktualisiert Juli 2025</p>
            <h1 className="font-heading text-3xl md:text-6xl font-bold text-white leading-tight max-w-3xl">
              Was ist der OOPBUY Spreadsheet?
            </h1>
            <p className="text-white/70 text-sm md:text-lg mt-4 max-w-xl">
              Der vollständige Leitfaden für deutsche Shopper — von der Einrichtung bis zum Versand
            </p>
            <div className="flex flex-wrap items-center gap-4 mt-6 text-white/60 text-xs">
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i> Lesezeit: 8 Minuten
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line"></i> Geschrieben von: Redaktionsteam
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-double-line"></i> Geprüft von: SEO Reviewer
              </span>
            </div>
          </div>
        </section>

        {/* Article Content */}
        <article className="bg-background-50 py-14 md:py-20">
          <div className="max-w-[800px] mx-auto px-4 md:px-6">
            {/* Meta */}
            <div className="flex flex-wrap items-center gap-3 mb-10 text-xs text-foreground-500">
              <span className="bg-accent-100 text-accent-800 px-2.5 py-1 rounded-full font-label">Einsteiger</span>
              <span className="bg-secondary-100 text-secondary-800 px-2.5 py-1 rounded-full font-label">Leicht</span>
              <span>Veröffentlicht: 15. Juli 2025</span>
              <span>Letzte Aktualisierung: 15. Juli 2025</span>
            </div>

            {/* Intro */}
            <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed text-sm md:text-base">
              <p className="text-foreground-900 font-medium text-base md:text-lg">
                Der <strong>OOPBUY Spreadsheet</strong> ist das ultimative Werkzeug für alle, die regelmäßig auf chinesischen Plattformen wie Taobao, Weidian und Yupoo einkaufen. Mit diesem Tool behältst du den Überblick über deine Bestellungen, Qualitätskontrollen und Versandprozesse — alles an einem Ort.
              </p>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4">
                Warum brauchst du den OOPBUY Spreadsheet?
              </h2>
              <p>
                Der Einkauf auf chinesischen Plattformen kann schnell unübersichtlich werden. Du bestellst bei verschiedenen <strong>Sellern</strong>, wartest auf <strong>QC-Bilder</strong> aus dem <strong>Warehouse</strong>, verfolgst den <strong>Versand</strong> nach Deutschland — und das alles für dutzende Artikel gleichzeitig. Ohne ein zentrales Tool verlierst du schnell den Überblick.
              </p>
              <p>
                Der OOPBUY Spreadsheet löst dieses Problem: Du erfasst jede <strong>Bestellung</strong> mit allen relevanten Daten, verfolgst den Status jedes <strong>Artikels</strong> vom Einkauf bis zur Lieferung und behältst alle <strong>Kosten</strong> im Blick. Das spart Zeit, vermeidet Fehler und gibt dir die Kontrolle über deinen gesamten Einkaufsprozess.
              </p>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4">
                Die wichtigsten Funktionen im Überblick
              </h2>
              <ul className="space-y-3 list-disc pl-5">
                <li><strong>Agent-Management:</strong> Verwalte mehrere Agenten und weise Bestellungen zu. Vergleiche Preise und Lieferzeiten direkt im Spreadsheet.</li>
                <li><strong>QC-Tracking:</strong> Erhalte und dokumentiere QC-Fotos für jeden Artikel. Entscheide direkt im Tool, ob du einen Artikel annimmst oder ablehnst.</li>
                <li><strong>Shipping-Tracking:</strong> Verfolge den Versandstatus jeder Lieferung, von der Abholung im Warehouse bis zur Zustellung in Deutschland.</li>
                <li><strong>Kostenübersicht:</strong> Behalte alle Ausgaben im Blick — vom Produktpreis über Agent-Gebühren bis zu Versandkosten und Zoll.</li>
                <li><strong>Batch-Verarbeitung:</strong> Verwalte große Mengen an Bestellungen mit der Batch-Funktion. Ideal für Reseller und Vielkäufer.</li>
              </ul>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4">
                So richtest du deinen OOPBUY Spreadsheet ein
              </h2>
              <p>
                Die Einrichtung ist denkbar einfach. Besuche <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">kaspreadsheet.com</a> und erstelle dein kostenloses Konto. Nach der Anmeldung erhältst du Zugriff auf deine persönliche Spreadsheet-Vorlage, die du sofort nutzen kannst.
              </p>
              <p>
                Der Spreadsheet ist mit allen gängigen Plattformen kompatibel: <strong>Taobao</strong> für Massenprodukte, <strong>Weidian</strong> für spezielle Fundstücke, <strong>Yupoo</strong> für Fotoalben von Sellern und <strong>1688</strong> für Großhandel. Du kannst Bestellungen von all diesen Plattformen in einem einzigen Spreadsheet zusammenführen.
              </p>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4">
                Tipps für den optimalen Workflow
              </h2>
              <ol className="space-y-3 list-decimal pl-5">
                <li><strong>Bestellung erfassen:</strong> Trage Produktlink, Preis, Größe und gewünschte Farbe ein.</li>
                <li><strong>Agent zuweisen:</strong> Wähle den passenden Agenten für deine Bestellung aus.</li>
                <li><strong>QC abwarten:</strong> Nach Eintreffen im Warehouse erhältst du QC-Fotos. Prüfe sie genau.</li>
                <li><strong>Versand auswählen:</strong> Wähle die beste Versandmethode für dein Budget und deine Zeitanforderungen.</li>
                <li><strong>Lieferung tracken:</strong> Verfolge dein Paket bis zur Haustür — alle Tracking-Informationen im Spreadsheet.</li>
              </ol>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4">
                Häufig gestellte Fragen (FAQ)
              </h2>
              <div className="space-y-4">
                {faqData.map((faq, idx) => (
                  <details key={idx} className="group border border-background-200/70 rounded-lg overflow-hidden">
                    <summary className="flex items-center justify-between p-4 cursor-pointer bg-background-100 hover:bg-background-200/70 transition-colors">
                      <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</span>
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                    </summary>
                    <div className="px-4 pb-4 pt-2 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>

              {/* CTA in article */}
              <div className="bg-primary-100/70 rounded-lg p-6 md:p-8 mt-10 text-center">
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">
                  Bereit für deinen OOPBUY Spreadsheet?
                </h3>
                <p className="text-foreground-600 text-sm mb-4">
                  Starte jetzt kostenlos und optimiere deinen Einkaufsprozess auf Taobao, Weidian & Yupoo.
                </p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Spreadsheet öffnen
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>

              {/* Author & Review */}
              <div className="border-t border-background-200/70 pt-8 mt-10">
                <div className="flex flex-col sm:flex-row gap-6 items-start">
                  <div className="w-16 h-16 rounded-full overflow-hidden bg-accent-100/80 flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20editor%20portrait%20in%20warm%20minimalist%20setting%20soft%20natural%20lighting%20clean%20german%20aesthetic%20editorial%20photography%20friendly%20approachable%20expression&width=200&height=200&seq=author-avatar-v1&orientation=squarish"
                      alt="Redaktionsteam Autor"
                      title="OOPBUY Spreadsheet Redaktionsteam Autor"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">Geschrieben von: Redaktionsteam OOPBUY</p>
                    <p className="text-sm font-semibold text-foreground-950">Geprüft von: SEO Reviewer & German Native Proofreader</p>
                    <p className="text-xs text-foreground-500 mt-1">Aktualisiert: 15. Juli 2025 · Revision 1.0</p>
                    <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                      Unser Redaktionsteam besteht aus deutschen Muttersprachlern mit umfassender Erfahrung im internationalen E-Commerce. Jeder Artikel durchläuft einen strengen Review-Prozess mit Faktenprüfung und Qualitätskontrolle, um höchste inhaltliche Standards zu gewährleisten.
                    </p>
                  </div>
                </div>
              </div>

              {/* Related Articles */}
              <div className="border-t border-background-200/70 pt-8 mt-8">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">Verwandte Artikel</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {relatedArticles.map((article) => (
                    <a
                      key={article.title}
                      href={article.url}
                      className="flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                    >
                      <i className="ri-arrow-right-line text-xs"></i>
                      {article.title}
                    </a>
                  ))}
                </div>
              </div>

              {/* Back to home */}
              <div className="mt-8 text-center">
                <a
                  href="/"
                  className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-left-line"></i>
                  Zurück zur OOPBUY Spreadsheet Startseite
                </a>
              </div>
            </div>
          </div>
        </article>
      </main>

      <Footer />

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </>
  );
}